import { render, staticRenderFns } from "./ModalExclusaoCompanyUnity.vue?vue&type=template&id=8010791c&scoped=true&"
import script from "./ModalExclusaoCompanyUnity.vue?vue&type=script&lang=js&"
export * from "./ModalExclusaoCompanyUnity.vue?vue&type=script&lang=js&"
import style0 from "./ModalExclusaoCompanyUnity.vue?vue&type=style&index=0&id=8010791c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8010791c",
  null
  
)

export default component.exports